import { doAction, doResponseAction } from ".";

const CAMERA_ALIGNMENT_LIST = "CAMERA_ALIGNMENT_LIST";
const CAMERA_ALIGNMENT_LIST_SUCCESS = "CAMERA_ALIGNMENT_LIST_SUCCESS";
const CAMERA_ALIGNMENT_LIST_FAILURE = "CAMERA_ALIGNMENT_LIST_FAILURE";

const CAMERA_ALIGNMENT_CAMERAS = "CAMERA_ALIGNMENT_CAMERAS";
const CAMERA_ALIGNMENT_CAMERAS_SUCCESS = "CAMERA_ALIGNMENT_CAMERAS_SUCCESS";
const CAMERA_ALIGNMENT_CAMERAS_FAILURE = "CAMERA_ALIGNMENT_CAMERAS_FAILURE";

const CAMERA_ALIGNMENT_REQUEST = "CAMERA_ALIGNMENT_REQUEST";
const CAMERA_ALIGNMENT_REQUEST_SUCCESS = "CAMERA_ALIGNMENT_REQUEST_SUCCESS";
const CAMERA_ALIGNMENT_REQUEST_FAILURE = "CAMERA_ALIGNMENT_REQUEST_FAILURE";

export {
    CAMERA_ALIGNMENT_LIST,
    CAMERA_ALIGNMENT_LIST_SUCCESS,
    CAMERA_ALIGNMENT_LIST_FAILURE,
    CAMERA_ALIGNMENT_CAMERAS,
    CAMERA_ALIGNMENT_CAMERAS_SUCCESS,
    CAMERA_ALIGNMENT_CAMERAS_FAILURE,
    CAMERA_ALIGNMENT_REQUEST,
    CAMERA_ALIGNMENT_REQUEST_SUCCESS,
    CAMERA_ALIGNMENT_REQUEST_FAILURE,
};

export const cameraAlignmentList = (params, callback) =>
    doAction(CAMERA_ALIGNMENT_LIST, params, callback);
export const cameraAlignmentListSuccess = (data = {}) =>
    doResponseAction(CAMERA_ALIGNMENT_LIST_SUCCESS, data);
export const cameraAlignmentListFailure = (data = {}) =>
    doResponseAction(CAMERA_ALIGNMENT_LIST_FAILURE, data);

export const cameraAlignmentCameras = (params, callback) =>
    doAction(CAMERA_ALIGNMENT_CAMERAS, params, callback);
export const cameraAlignmentCamerasSuccess = (data = {}) =>
    doResponseAction(CAMERA_ALIGNMENT_CAMERAS_SUCCESS, data);
export const cameraAlignmentCamerasFailure = (data = {}) =>
    doResponseAction(CAMERA_ALIGNMENT_CAMERAS_FAILURE, data);

export const cameraAlignmentRequest = (params, callback) =>
    doAction(CAMERA_ALIGNMENT_REQUEST, params, callback);
export const cameraAlignmentRequestSuccess = (data = {}) =>
    doResponseAction(CAMERA_ALIGNMENT_REQUEST_SUCCESS, data);
export const cameraAlignmentRequestFailure = (data = {}) =>
    doResponseAction(CAMERA_ALIGNMENT_REQUEST_FAILURE, data);
